// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D1nv","content":"styles_content___8h8p"};